export class ConfirmationModal{ 
    
    headerMessage:string;
    bodyMessage:string;

}


// WEBPACK FOOTER //
// ./src/app/modules/reports/custom-reports/entities/confirmation-modal.ts